var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":_vm.top,"right":_vm.right,"left":_vm.left,"bottom":_vm.bottom},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.tip))])])}
var staticRenderFns = []

export { render, staticRenderFns }